import { useBrand } from '../components/helpers/selectors'

const getImageHost = () => {
  const brand = useBrand()

  return `img${
    brand === 'money' ? '.money.co.uk' : brand === 'confused' ? '-fs.confused.com' : '.uswitch.com'
  }`
}

export default getImageHost
